// extracted by mini-css-extract-plugin
export default {"Container":"WidgetFooter_Container__EYIHG","Wrapper":"WidgetFooter_Wrapper__Ty11F","Title":"WidgetFooter_Title__FjeFu","Link":"WidgetFooter_Link__rFZiR"};